const backgroundVideos = document.querySelectorAll('.bg-video')
const showVideoOnLoad = (parent) => {
  if (!parent) return
  const video = parent.querySelector('.background-video')
  const button = parent.querySelector('.background-video__button')
  const container = parent.querySelector('.container')

  if (!video) return
  function showVideo() {
    video.classList.add('background-video--playing')
    button &&
      button.classList &&
      button.classList.add('background-video__button--visible')

    setTimeout(() => {
      button.classList.add('background-video__button--initialized')
    }, 2000)
  }

  const toggleVideoPlayback = () => {
    if (video.paused) {
      button.classList.remove('background-video__button--paused')
      video.play()
    } else {
      button.classList.add('background-video__button--paused')
      video.pause()
    }
  }

  video.currentTime ? showVideo() : video.addEventListener('play', showVideo)

  if (
    button &&
    button.classList &&
    button.classList.contains('background-video__button')
  ) {
    button.addEventListener('click', (ev) => {
      ev.stopPropagation()
      toggleVideoPlayback()
    })
  }
}
backgroundVideos &&
  backgroundVideos.length &&
  backgroundVideos.forEach(showVideoOnLoad)
